module.exports = __webpack_public_path__ + "static/media/play-soul.59aebddd.png";